export default {
  methods: {
    formatCurrency(value, currency = null, divideBy = 1, digits = 2) {
      if (value === null) return;
      value /= divideBy;
      if (currency === null) {
        return new Intl.NumberFormat(this.$i18n.locale, {
          style: 'decimal',
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        }).format(value);
      } else {
        return new Intl.NumberFormat(this.$i18n.locale, {
          style: 'currency',
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
          currency,
        }).format(value);
      }
    },
    formatNumber(value) {
      if (value === null) return;
      return new Intl.NumberFormat(this.$i18n.locale, {
        style: 'decimal',
      }).format(value);
    },
  },
};
